import {
  approvedLeaveDatesSet,
  calculateTotalWorkingDays,
  convertToFullDate,
  daysWorkedSet,
  formatDate,
  isInHourRange,
  resetWorkData,
} from "../../assets/config/helpers.js";
import {
  halfDay,
  monthMap,
  monthNames,
  monthShortNames,
  newLateThresholds
} from "../../assets/config/constants";
import firebase from "firebase/app";
import "firebase/database";
import { createPayrollObject, processLeavesData } from "../../components/PayrollManagement/payrollHelper.js";
import firebaseAPI from "../../assets/config/firebase.js";
import { subtractHolidays } from "../../utils/excludeholidayHours.js";
import { settings } from "../../utils/genralSpecificSettings.js";

const payroll = {
  // namespaced: true,
  state: {
    allPayrollList: null,
    selectedEmployeePayroll: {},
    selectedMonth: new Date().toLocaleString("default", { month: "long" }),
    selectedYear: new Date().getFullYear(),
    payrollData: [],
    loading: false,
  },
  mutations: {
    setAllPayrollList(state, payload) {
      state.allPayrollList = payload;
    },
    setSelectedEmployeePayroll(state, payload) {
      state.selectedEmployeePayroll = payload;
    },
    setSelectedMonth(state, month) {
      state.selectedMonth = month;
    },
    setSelectedYear(state, year) {
      state.selectedYear = year;
    },
    clearPayroll(state) {
      state.allPayrollList = null;
      state.selectedEmployeePayroll = null;
      state.selectedYear = new Date().getFullYear();
      state.selectedMonth = new Date().toLocaleString("default", { month: "long" });
      state.loading = false;
      state.payrollData = null;
    },
    setPayrollData(state, data) {
      state.payrollData = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
  getters: {
    AllPayrollList: state => () => state.allPayrollList,
    AllSelectedPayroll: state => () => state.selectedEmployeePayroll,
    selectedPayrollMonth: state => () => state.selectedMonth,
    selectedPayrollYear: state => () => state.selectedYear,
    filteredPayrollListByMonthYear: state => () => {
      if (!state.allPayrollList) return [];
      return state.allPayrollList.filter(p =>
        p.month === state.selectedMonth && p.year === String(state.selectedYear)
      );
    }
  },
  actions: {
    async fetchConstants() {
      const constantsRef = firebase.database().ref("constants");
      const constantsSnapshot = await constantsRef.once("value");
      return constantsSnapshot.exists() ? constantsSnapshot.val() : {};
    },

    async fetchPayrollRealTime({ state, commit, dispatch }, { router }) {
      try {
        commit('setLoading', true);

        const selectedYear = state.selectedYear || new Date().getFullYear();
        const selectedMonth = state.selectedMonth || monthNames[new Date().getMonth()];
        const selectedMonthShort = monthShortNames[selectedMonth];

        const payrollRef = await dispatch('getPayrollRef', {
          year: selectedYear,
          month: selectedMonth
        });

        if (!payrollRef || typeof payrollRef.on !== 'function') {
          console.error("Invalid payroll reference");
          commit("setLoading", false);
          return;
        }

        payrollRef.off();

        payrollRef.on("value", async (snapshot) => {
          await dispatch('processPayrollSnapshot', {
            snapshot,
            year: selectedYear,
            month: selectedMonth,
            monthShort: selectedMonthShort,
            router
          });
        }, (error) => {
          dispatch('handleFirebaseError', error);
        });

      } catch (err) {
        console.error("Error fetching payroll data:", err);
        dispatch('handleFirebaseError', err);
        commit('setLoading', false);
      }
    },

    // async fetchPayrollRealTime({ state, commit, dispatch }) {
    //   commit('setLoading', true);

    //   const selectedYear = state.selectedYear || new Date().getFullYear();
    //   const selectedMonth = state.selectedMonth || monthNames[new Date().getMonth()];
    //   const selectedMonthShort = monthShortNames[selectedMonth];

    //   const payrollRef = await dispatch('getPayrollRef', { year: selectedYear, month: selectedMonth });

    //   if (!payrollRef) {
    //     console.error("Payroll reference is null");
    //     commit("setLoading", false);
    //     return;
    //   }

    //   payrollRef.off();

    //   payrollRef.on("value", async (snapshot) => {
    //     await dispatch('processPayrollSnapshot', {
    //       snapshot,
    //       year: selectedYear,
    //       month: selectedMonth,
    //       monthShort: selectedMonthShort
    //     });
    //     commit('setLoading', false);
    //   }, (error) => {
    //     dispatch('handleFirebaseError', error);
    //   });
    // },

    getPayrollRef({ state, rootState }, { year, month }) {
      const user = rootState.auth.user;
      const isAdmin = user.role === "admin" || false;
      if (isAdmin) {
        return firebase.database().ref(`payroll/${year}/${month}`);
      }

      if (!user) return null;
      return firebase.database().ref(`payroll/${year}/${month}`)
        .orderByChild('employeeId')
        .equalTo(user.uid);
    },

    async processPayrollSnapshot({ state, rootState, commit, dispatch }, { snapshot, year, month, monthShort, router }) {
      const user = rootState.auth.user;
      const isAdmin = user.role === "admin" || false;

      const existingPayrolls = snapshot.exists() ? snapshot.val() : {};

      const payrolls = await dispatch('mapPayrollData', existingPayrolls);

      if (!isAdmin) {
        // dispatch('handleNonAdminPayroll', payrolls);
        const routingFn = (item) => {
          if  (item && (item.status || "").toLowerCase() === "processed"){
            router.push({
              name: "Payroll Details",
              params: {
                employeeId: item.employeeId,
                employee: item
              }
            });
          }
        }
        dispatch('handleNonAdminPayroll', {
          payrolls,
          callback: routingFn
        });

        return;
      }

      const updatedPayrolls = await dispatch('processMissingEmployees', {
        payrolls,
        year,
        month,
        monthShort
      });
      dispatch('updatePayrollData', updatedPayrolls);
      commit('setLoading', false);
    },

    mapPayrollData({ }, payrolls) {
      return Object.keys(payrolls).map(payrollId => {
        const payroll = payrolls[payrollId];
        return createPayrollObject(payrollId, payroll);
      });
    },

    handleNonAdminPayroll({ commit }, { payrolls, callback }) {
      commit("setPayrollData", payrolls);
      commit("setAllPayrollList", payrolls);


      if (payrolls.length > 0) {
        commit("setSelectedEmployeePayroll", payrolls[0]);
        if (callback) callback(payrolls[0]);
        commit("setLoading", false);
      }
    },
    async processMissingEmployees({ state, rootState, dispatch }, { payrolls, year, month, monthShort }) {
      const existingEmployeeIds = payrolls.map(p => p.employeeId);
      const company = rootState.auth.company;
      const companyUserIds = company.users.map(u => u.uid);
      const allEmployees = rootState.auth.allUsers.filter(u => companyUserIds.includes(u.uid));
      const missingEmployees = allEmployees.filter(emp => !existingEmployeeIds.includes(emp.uid));

      let constants = (rootState.constants && rootState.constants.constant) || await dispatch('fetchConstants');
      const holidays = await firebaseAPI.getAllHolidays();

      const monthNumber = typeof month === "string" ? monthMap[month] : month;

      const newPayrollEntries = await Promise.all(
        missingEmployees.map(async (emp) => {

          const leavesSnapshot = await firebase.database().ref("leaves")
            .orderByChild("userId")
            .equalTo(emp.uid)
            .once("value");
          const empLeaves = leavesSnapshot.val() || {};

          const timePeriodSnapshot = await firebase.database().ref("timePeriod")
            .orderByChild("userId")
            .equalTo(emp.uid)
            .once("value");
          const allTimePeriods = timePeriodSnapshot.val() || {};

          const empTimePeriods = {};
          Object.entries(allTimePeriods).forEach(([key, record]) => {
            const timeIn = record.timeIn ? new Date(record.timeIn) : null;
            if (timeIn && timeIn.getFullYear() === year && (timeIn.getMonth() + 1) === monthNumber) {
              empTimePeriods[key] = record;
            }
          });
          
          const mockSnapshot = {
            forEach: (callback) => {
              Object.entries(empTimePeriods).forEach(([key, value]) => {
                callback({ val: () => value });
              });
            }
          };
          
          return dispatch('createPayrollForEmployee', {
            emp,
            selectedYear: year,
            selectedMonth: month,
            constantsCollection: constants,
            preFetchedHolidays: holidays,
            preFetchedLeaves: empLeaves,
            preFetchedSnapshot: mockSnapshot
          })
        })
      );

      return payrolls.concat(newPayrollEntries);
    },

    updatePayrollData({ commit }, payrolls) {
      commit("setPayrollData", payrolls);
      commit("setAllPayrollList", payrolls);
    },

    handleFirebaseError({ commit }, error) {
      console.error("Firebase error:", error);
      commit("setLoading", false);
    },


    async fetchEmployeeLeaves({ }, employeeId) {
      const leavesRef = firebase.database().ref("leaves").orderByChild("userId").equalTo(employeeId);
      const leavesSnapshot = await leavesRef.once("value");
      return leavesSnapshot.val() || {};
    },

    async calculateAttendanceStats({ }, { userId, year, month, empWorkingDays, empTotalHours, preFetchedSnapshot = null, emp }) {
      resetWorkData()
      const monthNumber = typeof month === "string" ? monthMap[month] : month;
      let snapshot;
      if (preFetchedSnapshot) {
        snapshot = preFetchedSnapshot;
      } else {
        const timePeriodRef = firebase.database().ref("timePeriod").orderByChild("userId").equalTo(userId);
        snapshot = await timePeriodRef.once("value");
      }

      const isResigned = ((emp && emp.status) || '').toLowerCase() === 'resigned';

      const lastWorkingDateObj = isResigned && emp && emp.lastWorkingDate
        ? new Date(emp.lastWorkingDate)
        : null;
      const holidays = await firebaseAPI.getAllHolidays();

      const empWorkingDaysLowerForHolidays = empWorkingDays.map(day => day.toLowerCase());
      const empShift = ((emp && emp.shift) || 'morning').toLowerCase();

      const eligibleHolidayDays = [];
      const eligibleHolidayDetails = [];
      const deductedHolidayDates = new Set();

      for (const holiday of holidays) {
        const holidayDate = new Date(holiday.dates);
        const holidayYear = holiday.isRecurring ? year : holidayDate.getFullYear();
        const holidayStart = new Date(holidayYear, holidayDate.getMonth(), holidayDate.getDate());

        for (let i = 0; i < holiday.numberOfDays; i++) {
          const actualHolidayDate = new Date(holidayStart);
          actualHolidayDate.setDate(actualHolidayDate.getDate() + i);

          if (
            actualHolidayDate.getFullYear() !== year ||
            actualHolidayDate.getMonth() !== (monthNumber - 1)
          ) {
            continue;
          }

          if (lastWorkingDateObj && actualHolidayDate > lastWorkingDateObj) {
            continue;
          }

          const holidayWeekday = actualHolidayDate.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
          const holidayShift = (holiday.shift || "general").toLowerCase();

          if (
            empWorkingDaysLowerForHolidays.includes(holidayWeekday) &&
            (holidayShift === empShift || holidayShift === "general")
          ) {
            const dateKey = `${actualHolidayDate.getFullYear()}-${String(actualHolidayDate.getMonth() + 1).padStart(2, '0')}-${String(actualHolidayDate.getDate()).padStart(2, '0')}`;
            if (!deductedHolidayDates.has(dateKey)) {
              deductedHolidayDates.add(dateKey);
              eligibleHolidayDays.push(actualHolidayDate.getDate());
              eligibleHolidayDetails.push(
                `${String(actualHolidayDate.getDate()).padStart(2, '0')}-${String(actualHolidayDate.getMonth() + 1).padStart(2, '0')}-${actualHolidayDate.getFullYear()}: ${holiday.name}`
              );
            }
          }
        }
      }
    
      let lateArrivals = 0;
      let totalHours = 0;
      let productiveHours = 0;
      let empWorkingDayObj = {};
      let requiredWorkingDayObj = {};
    
      const lowHoursDays = {};
      const normalHoursDays = {};
      const halfHoursDays = {};
      let remainingHalfDays = {};
      let totalExtraHoursDays = {};
      let totalLowHours = 0;
      let totalNormalHours = 0;
      let totalExtraHours = 0;
      let totalHalfDayHours = 0;
      let remainingHalfDayHours = 0;
      let overallMonthlyTotalHours = 0;
      let absentDays = {}
    
      const halfDayHours = (Number(empTotalHours) / 2) + 0.5;
      const halfDayUpperThreshold = Math.floor(halfDayHours) + (59 / 60);


      snapshot.forEach(childSnapshot => {
        const record = childSnapshot.val();
        let timeIn = null;
        const isNightShift = emp.shift && emp.shift.toLowerCase() === "night";
        if (isNightShift) {
          timeIn = record.createdAt ? new Date(record.createdAt) : null;
        } else {
          timeIn = record.timeIn ? new Date(record.timeIn) : null;
        }

        if (!timeIn || isNaN(timeIn)) {
          console.warn("Skipping invalid timeIn:", record);
          return;
        }
    
        const recordMonth = timeIn.getMonth() + 1;
        const recordYear = timeIn.getFullYear();
        const recordDay = timeIn.getDate();
        const recordWeekday = timeIn.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
    
        if (recordMonth !== monthNumber || recordYear !== year) return;
    
        if (empWorkingDays.map(day => day.toLowerCase()).includes(recordWeekday)) {
          daysWorkedSet.add(recordDay);
        }
    
        if (record.late && ((record.late.hours || 0) > 0 || (record.late.minutes || 0) > 0)) {
          lateArrivals++;
        }
    
        let workedHours = 0;

        if (Array.isArray(record.sessions)) {
          for (let i = 0; i < record.sessions.length; i++) {
            const session = record.sessions[i];
            const sessionIn = session.timeIn ? new Date(session.timeIn) : null;
            let sessionOut = session.timeOut ? new Date(session.timeOut) : null;
        
            // If this is the last session and timeOut is missing
            if (!sessionOut && i === record.sessions.length - 1 && Array.isArray(record.screenshots) && record.screenshots.length > 0) {
              const lastScreenshot = record.screenshots[record.screenshots.length - 1];
              sessionOut = new Date(lastScreenshot.timestamp);
            }
        
            if (sessionIn && sessionOut) {
              const sessionDuration = (sessionOut - sessionIn) / (1000 * 60 * 60); // in hours
              workedHours += sessionDuration;
              productiveHours += sessionDuration;
            }
          }
        }

        totalHours += workedHours;

        const isInHalfDayRange = isInHourRange(halfDayHours)
        if (workedHours > 0) {
          // Check if the worked day is in the empWorkingDays set
          const isWorkingDay = empWorkingDays.map(day => day.toLowerCase()).includes(recordWeekday);
          
          if (isWorkingDay) {
            // If it is a working day, proceed with existing logic for low, mid, or extra hours
            if (workedHours < halfDayHours) {
              //Day is less than half day hours
              lowHoursDays[recordDay] = workedHours;
              totalLowHours += workedHours;
              // absentDays[recordDay] = Number(workedHours || 0)
              delete empWorkingDayObj[recordDay]
              delete requiredWorkingDayObj[recordDay]
              
            } else if (isInHalfDayRange && workedHours <= halfDayUpperThreshold && workedHours >= halfDayHours ) {
              // 5:00 to 5:59 - withing half day range
              halfHoursDays[recordDay] = workedHours;
              totalHalfDayHours += workedHours;
              
              remainingHalfDays[recordDay] = Number(empTotalHours || 0) - Number(workedHours || 0);
              remainingHalfDayHours += Number(empTotalHours || 0) - Number(workedHours || 0)

              // adding those remaining required halfday hours to total monthly hours
              // empWorkingDayObj[recordDay] = Number(empTotalHours || 0) - Number(halfDayHours || 0)

            } else if (workedHours > halfDayUpperThreshold && workedHours <= empTotalHours) {
              normalHoursDays[recordDay] = workedHours;
              totalNormalHours += workedHours;
            } else if (workedHours > empTotalHours) {
              const normalHours = empTotalHours;
              const extra = workedHours - empTotalHours;
              
          
              normalHoursDays[recordDay] = normalHours;
              totalNormalHours += normalHours;
              
              totalExtraHours += extra;
              totalExtraHoursDays[recordDay] = extra;
            }
          } else {
            // If it's not a working day, count all hours as extra
            totalExtraHours += workedHours;
            totalExtraHoursDays[recordDay] = workedHours;
          }
        }
      });

      eligibleHolidayDays.forEach(day => daysWorkedSet.add(day));

      const daysWorked = daysWorkedSet.size;
      const empWorkingDaysLower = empWorkingDays.map(day => day.toLowerCase());
      const daysInMonth = new Date(year, monthNumber, 0).getDate();
      // approvedLeaveDatesSet is keyed "Jun 15" style; resolve the short name once
      // so the lookup below works whether `month` is a name or a month number.
      const monthFullName = Object.keys(monthMap).find((k) => monthMap[k] === Number(monthNumber));
      const monthShortName = monthShortNames[monthFullName] || "";
      let absents = 0;
    
      for (let day = 1; day <= daysInMonth; day++) {
        const checkDate = new Date(year, monthNumber - 1, day);
        const weekDayName = checkDate.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
    
        if (!empWorkingDaysLower.includes(weekDayName)) continue;

        if (lastWorkingDateObj && checkDate > lastWorkingDateObj) continue;

        overallMonthlyTotalHours += Number(empTotalHours || 0);
        // approvedLeaveDatesSet is keyed by short month name ("Jun 15"), see
        // processLeavesData in payrollHelper.js. Comparing it against
        // `${monthNumber} ${day}` ("6 15") never matched, so approved leave days
        // were treated as absences.
        const leaveKey = `${monthShortName} ${day}`;
        if (approvedLeaveDatesSet.has(leaveKey)) {
          continue;
        }

        empWorkingDayObj[day] = Number(empTotalHours || 0);
        requiredWorkingDayObj[day] = Number(empTotalHours || 0);

        if(remainingHalfDays[day] > 0){
          empWorkingDayObj[day] = Number(empTotalHours || 0) - Number(halfDayHours || 0)
          requiredWorkingDayObj[day] = Number(halfDayHours || 0)
        };
        const dayWorkedArray = [...daysWorkedSet]
        if (!dayWorkedArray.includes(day)) {
          absents++;
          // absentDays[day] = Number(empTotalHours || 0)
          absentDays[day] = "Off"
          delete empWorkingDayObj[day];
          delete requiredWorkingDayObj[day];
        }
      }   

      const approvedLeaveDatesArray = Array.from(approvedLeaveDatesSet || []);
      const approvedLeaves = [...approvedLeaveDatesArray]
        .filter(date => {
          const fullDate = convertToFullDate(date, year, monthNumber);
          const leaveDate = new Date(fullDate);

          return leaveDate.getFullYear() === year && (leaveDate.getMonth() + 1) === monthNumber;
        })
        .map(date => {
          const fullDate = convertToFullDate(date, year, monthNumber);
          const leaveDate = new Date(fullDate);

          let [_, day] = date.split(" ");
          delete empWorkingDayObj[day];
          delete requiredWorkingDayObj[day];
          return formatDate(leaveDate);
        });

      const safeMonthlyLeaves = JSON.parse(JSON.stringify(approvedLeaves));
      const approvedLeavesCount = approvedLeaveDatesArray.filter(date => {
        const fullDate = convertToFullDate(date, year, monthNumber);
        const leaveDate = new Date(fullDate);
        return leaveDate.getFullYear() === year && (leaveDate.getMonth() + 1) === monthNumber;
      }).length;

      // const requiredTotalWorkingHours = Object.values(empWorkingDayObj).reduce((acc, curr) => acc+curr, 0) || overallMonthlyTotalHours
      const requiredTotalWorkingHours = Object.values(requiredWorkingDayObj).reduce((acc, curr) => acc+curr, 0) || overallMonthlyTotalHours


      return {
        lateArrivals,
        totalHours,
        productiveHours,
        daysWorked,
        absents: Math.max(0, absents - approvedLeavesCount),
        lowHoursDays,
        totalLowHours,
        normalHoursDays,
        totalNormalHours,
        totalExtraHours,
        monthlyLeaves: safeMonthlyLeaves,
        halfHoursDays,
        totalHalfDayHours,
        remainingHalfDays,
        remainingHalfDayHours,
        requiredTotalWorkingHours,
        requiredTotalWorkingDays: requiredWorkingDayObj,
        absentDays,
        totalExtraHoursDays,
        eligibleHolidayDetails,
      };
    },
    
    calculateAnnualLeavesEncashmentDays({ }, { remainingLeaves, month = "December" }) {
      if (month !== "December") return 0;
      const remaining = Math.min(Math.floor(remainingLeaves || 0), 5);
      const encashmentRules = { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3 };
      return encashmentRules[remaining] || 0;
    },

    async calculateFinalAmount({ dispatch }, props) {
      const {
        obtainedLeaves,
        perDaySalary,
        lateArrivals,
        totalDaysSalary,
        leaveBalance,
        month,
      } = props || {};

      const currentMonth = month || new Date().toLocaleString("default", { month: "long" });
      const leavesTaken = parseInt(obtainedLeaves) || 0;
      const lates = parseInt(lateArrivals) || 0;

      let leaveDeductionDays = 0;
      let lateDeductionDays = 0;

      for (let i = 0; i < newLateThresholds.length; i++) {
        const threshold = newLateThresholds[i];
        if (lates >= threshold.min) {
          lateDeductionDays = threshold.salaryDeduct;
          leaveDeductionDays = leavesTaken > 0 ? 1 : 0;
          break;
        }
      }

      const lateSalaryDeduction = lateDeductionDays * perDaySalary;
      const calcAnnualLeavesEncashmentDays = await dispatch('calculateAnnualLeavesEncashmentDays', {
        remainingLeaves: leaveBalance,
        month: currentMonth
      });
      const calcAnnualLeavesEncashmentSalary = Number(calcAnnualLeavesEncashmentDays) * Number(perDaySalary) || 0;
      const leavesTakenEncashmentAmount = (Number(obtainedLeaves) - Number(leaveDeductionDays)) * Number(perDaySalary) || 0;

      const calculateFinalSalary = Number(totalDaysSalary || 0) -
        Number(lateSalaryDeduction) +
        Number(leavesTakenEncashmentAmount) +
        Number(calcAnnualLeavesEncashmentSalary);
      return calculateFinalSalary.toFixed(2);
    },


    async createPayrollForEmployee({ rootState, dispatch }, { 
      emp, 
      selectedYear, 
      selectedMonth, 
      constantsCollection,
      preFetchedHolidays = null,
      preFetchedLeaves = null,
      preFetchedSnapshot = null
    }) {
      if(!emp) return null;   
      const selectedMonthShort = monthShortNames[selectedMonth];
      let leavesData;
      if (preFetchedLeaves) {
        leavesData = preFetchedLeaves;
      } else {
        leavesData = await dispatch("fetchEmployeeLeaves", emp.uid || emp.employeeId);
      }
      const { obtainedLeaves } = processLeavesData(leavesData, selectedMonthShort, selectedYear);

      const userSalary = emp.basicSalary || emp.salary || 0;
      const userExtraAllowance = emp.extraAllowance || 0;
      const userGrossSalary = Number(userSalary) + Number(userExtraAllowance);

      let constants = null
      let fetchedContants = null
      if (!emp.workingDays && !constantsCollection) {
        if (rootState.constants && rootState.constants.constant) {
          constants = rootState.constants.constant
        } 
      } else {
        fetchedContants = await dispatch('fetchConstants');
      }
      const empWorkingDays = emp.workingDays || fetchedContants.days || (constantsCollection ? constantsCollection.days || constantsCollection.constant.days : []) || constants && constants.days;
      const empTotalHours = Number(emp.productiveHours) || Number(fetchedContants.totalHours) || (constantsCollection ? Number(constantsCollection.totalHours || constantsCollection.constant.totalHours) : 0);
      let requiredWorkingDaysInMonth = calculateTotalWorkingDays(selectedYear, selectedMonth, empWorkingDays);
      let attendanceStats;
      if (preFetchedSnapshot) {
        attendanceStats = await dispatch("calculateAttendanceStats", {
          userId: emp.uid,
          year: selectedYear,
          month: selectedMonth,
          empWorkingDays,
          empTotalHours,
          preFetchedSnapshot: preFetchedSnapshot,
          emp
        });
      } else {
        attendanceStats = await dispatch("calculateAttendanceStats", {
          userId: emp.uid,
          year: selectedYear,
          month: selectedMonth,
          empWorkingDays,
          empTotalHours,
          emp
        });
      }

      const holidays = preFetchedHolidays || await firebaseAPI.getAllHolidays();
      

      const calcRequiredWorkingHrs = Number(requiredWorkingDaysInMonth) * Number(empTotalHours || 0);

      const {
        lowHoursDays,
        totalLowHours,
        normalHoursDays,
        totalNormalHours,
        totalExtraHours,
        monthlyLeaves,
        halfHoursDays,
        totalHalfDayHours,
        remainingHalfDays,
        remainingHalfDayHours,
        requiredTotalWorkingDays,
        requiredTotalWorkingHours,
        absentDays,
        totalExtraHoursDays,
        eligibleHolidayDetails,
      } = attendanceStats || {};

      const lowHoursDaysCount = Object.keys(lowHoursDays).length || 0;

      const leaveBalance = Number(emp.leavesAvailable || 0) - Number(emp.leavesTaken || 0) || 0;
      const userPerDaySalary = requiredWorkingDaysInMonth ?
        parseFloat((userGrossSalary / requiredWorkingDaysInMonth).toFixed(2)) :
        0;

      const totalDaysSalary = userPerDaySalary * attendanceStats.daysWorked;
      const remainingHalfDaysCount = Object.keys(remainingHalfDays).length || 0;
      const absentCount = Math.max(0, attendanceStats.absents + (remainingHalfDaysCount * halfDay || 0) + Number(lowHoursDaysCount))
      const updatedDaysWorkedSalary = userPerDaySalary * (Number(requiredWorkingDaysInMonth  || 0) - Number(obtainedLeaves || 0) -  Number(absentCount || attendanceStats.absents || 0) - Number(lowHoursDaysCount || 0))

      const finalAmount = await dispatch("calculateFinalAmount", {
        obtainedLeaves,
        perDaySalary: userPerDaySalary,
        totalDaysSalary: updatedDaysWorkedSalary,
        lateArrivals: attendanceStats.lateArrivals,
        leaveBalance,
        month: selectedMonth,
      });
      const halfHourLen = Object.keys(halfHoursDays).length || 0;
      const eligibleHolidayCount = (eligibleHolidayDetails || []).length;
      const countDaysWorked = Object.keys(normalHoursDays).length + (halfHourLen && halfHourLen * halfDay) + eligibleHolidayCount || 0;

      const lates = parseInt(attendanceStats.lateArrivals) || 0;

      let leaveDeductionDays = 0;
      let lateDeductionDays = 0;

      for (let i = 0; i < newLateThresholds.length; i++) {
        const threshold = newLateThresholds[i];
        if (lates >= threshold.min) {
          lateDeductionDays = threshold.salaryDeduct;
          leaveDeductionDays = threshold.leaveDeduct || 0;
          break;
        }
      }


      return {
        payrollId: firebase.database().ref().push().key,
        employeeId: emp.uid,
        employeeName: emp.username || "Unknown",
        employeeDesignation: emp.designation ? `Grade-${emp.grade || 1 } - ${emp.designation}` : "",
        isSuperAdmin: emp.isSuperAdmin,
        joiningDate: emp.joiningDate,
        grossSalary: userGrossSalary,
        calculatedSalary: totalDaysSalary,
        basicSalary: userSalary,
        perDaySalary: userPerDaySalary,
        requiredWorkingDays: Number(requiredWorkingDaysInMonth) || 0,
        finalAmount: Math.round(finalAmount),
        transactionFees: 0,
        extraAllowance: userExtraAllowance || 0,
        extraAmountAdjustment: 0,
        bonus: 0,
        daysWorked: countDaysWorked || 0,
        totalDaysWorked: attendanceStats.daysWorked,
        normalDaysWorked: Object.keys(normalHoursDays).length,
        obtainedLeaves: `${obtainedLeaves} / ${leaveBalance}`,
        actualAbsents: Number(attendanceStats.absents),
        absents: Number(absentCount),
        lateDeduction: `${Number(userPerDaySalary) * Number(lateDeductionDays)} - ${attendanceStats.lateArrivals}`,
        lateDeductionDays: 0,
        resignationDate: emp.resignationDate || null,
        lastWorkingDate: emp.lastWorkingDate || null,
        eligibleHolidayDetails: eligibleHolidayDetails || [],
        lateArrivals: attendanceStats.lateArrivals,
        productiveHours: attendanceStats.totalHours || Number(empTotalHours),
        status: "Pending",
        month: selectedMonth,
        year: selectedYear,
        remainingLeaves: leaveBalance,
        carryForwardDays: 0,
        updatedLeaveQuota: 0,
        leavesAvailable: Number(emp.leavesAvailable),
        leavesAllowed: Number(emp.leavesAllowed),
        leavesTaken: Number(emp.leavesTaken),
        leaveBalance: Number(leaveBalance),
        leaveDeductionCount: 0,
        constantLeaveAllowed: constantsCollection ? constantsCollection.leavesAllowed : 0,
        leavesEncashmentDays: 0,
        leavesEncashmentAmount: 0,
        annualLeavesEncashmentDays: 0,
        totalNormalHours: totalNormalHours || 0,
        totalExtraHours: totalExtraHours || 0,
        totalLowHours: totalLowHours || 0,
        // lowHoursDaysCount: lowHoursDaysCount || 0,
        lowHoursDays: lowHoursDays || {},
        reqWorkingHours: calcRequiredWorkingHrs || 0,
        monthlyLeaves: monthlyLeaves || [],
        extraAmountAdjustmentNote: "",
        halfDays: halfHoursDays || {},
        totalHalfDayHours,
        remainingHalfDays,
        remainingHalfDayHours,
        leaveDeductionNote: "",
        requiredTotalWorkingDays,
        requiredTotalWorkingHours,
        perDayProductiveHours: Number(empTotalHours),
        newLeaveBalance: 0,
        leavesAllowed: Number(emp.leavesAllowed || 0),
        leavesAvailable: Number(emp.leavesAvailable || 0),
        DBLeavesTaken: Number(emp.leavesTaken || 0),
        leavesDeductionDays: null,
        absentDays,
        totalExtraHoursDays,
        empTotalHours,
        normalHoursDays,
        taxDeduction: 0,
        employeeStatus: emp.status,
        shift: (emp.shift || "Morning").toLowerCase(),
        leavesQuota: emp.leavesQuota || {},
        workingDays: emp.workingDays,
      };
    },
  }
};

export default payroll;



// WEBPACK FOOTER //
// ./src/store/modules/payroll.js